import React from 'react'
import PropTypes from 'prop-types'
import { cx } from '@emotion/css'
import { Chip } from '@offerzen/pinata-shame'

import { ApplicationStatus } from '@/CandidateExperience/constants/applicationStatus'

import { applicationStatusLabel, applicationStatusTheme } from './constants'
import styles from './styles'

const ApplicationStatusChip = ({ applicationStatus, className, verbose = false }) => {
  if (!applicationStatus) return null

  let label = applicationStatusLabel[applicationStatus]
  if (verbose) {
    label = `Application ${label.toLowerCase()}`
  }

  return <Chip className={cx(styles.chip, className)} theme={applicationStatusTheme[applicationStatus]} label={label} size="default" />
}

ApplicationStatusChip.propTypes = {
  applicationStatus: PropTypes.oneOf(Object.values(ApplicationStatus)),
  className: PropTypes.string,
  verbose: PropTypes.bool,
}

export default ApplicationStatusChip
